export default __webpack_public_path__ + "static/media/icon-transmettre.b13f9696.svg";